<div class="container py-4" *ngIf="zone !== '#all$'">
  <div class="capacity-details">
    <div class="capacity-card" *ngIf="!show" [ngStyle]="{ background: getBackground() }">
      <div class="settings-icon">
        <mat-icon *ngIf="showSettingsIcon()" (click)="viewCardDetails(); showSetting()">settings</mat-icon>
      </div>
      <div class="card-content" (click)="viewCardDetails()">
        <div class="title">Available Capacity</div>
        <div class="capacity-numbers" *ngIf="zone?.max_capacity">
          {{ zone?.max_capacity - getCurrentCheckinCount() }}
        </div>
        <div class="capacity-numbers" *ngIf="!zone?.max_capacity">
          <mat-icon class="infinit-number">all_inclusive</mat-icon>
        </div>
      </div>
    </div>
    <div class="show-capacity-card" *ngIf="show" [ngStyle]="{ height: showSettings ? 'auto' : '315px' }">
      <div class="settings-icon">
        <mat-icon *ngIf="showSettingsIcon()" (click)="showSettingsChanged()">settings</mat-icon>
      </div>
      <div class="card-content">
        <div class="title" (click)="viewCardDetails()">currently at venue</div>
        <div class="capacity-numbers" (click)="viewCardDetails()">
          <span class="current-num" [ngStyle]="{ color: getBackground() }">{{ getCurrentCheckinCount() }}</span>
          <span *ngIf="zone.max_capacity" class="total">{{ ' /' + zone?.max_capacity }}</span>
        </div>

        <div class="settings-placeholder" *ngIf="!showSettings" (click)="viewCardDetails()">
          <div (click)="viewCardDetails()" class="notice" *ngIf="zone.max_capacity && !showSettings" [ngStyle]="{ display: getPercentage() < 75 ? 'none' : 'block' }">
            <span *ngIf="getPercentage() >= 75 && getPercentage() < 100" [ngStyle]="{ color: getPercentage() >= 100 ? '#CE1126' : '#F97017' }">Almost full</span>
            <span *ngIf="getPercentage() >= 100" [ngStyle]="{ color: getPercentage() >= 100 ? '#CE1126' : '#F97017' }">Over limit</span>
          </div>
        </div>
        <div class="settings-content" *ngIf="showSettings">
          <span class="input-label">Change capacity</span>
          <input type="text" name="capacityNum" class="form-control" [(ngModel)]="capacityNum" placeholder="0 means unlimited ∞" />
          <span class="icon" (click)="updateCapacity()">
            <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.80705 21.6544C1.11361 21.4113 0.735425 20.6727 0.942445 19.9703C1.04145 19.6372 1.6449 18.9977 5.34618 15.2874L9.6419 10.9828L5.34618 6.68734C1.6449 2.96802 1.04145 2.32848 0.942445 1.9954C0.645225 0.968657 1.62686 -0.00374313 2.68946 0.266417C3.02276 0.356397 3.61698 0.923777 7.99388 5.29144C12.2716 9.56912 12.9289 10.2716 13.0279 10.6047C13.2622 11.4242 13.3973 11.262 8.08387 16.6023C3.34705 21.3574 2.86062 21.7895 2.34736 21.7804C2.24814 21.7804 2.00505 21.7265 1.80705 21.6544Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
        @if(authService.user.is_admin){
        <div class="settings-content force-checkout-row" *ngIf="showSettings">
          <button class="force-checkout-btn" (click)="openForceCheckOutConfirm()">Force Check-Out</button>
        </div>
        }
        <div class="progress-bar" *ngIf="zone.max_capacity" (click)="viewCardDetails()">
          <div class="bar">
            <span
              class="bar-bg"
              [ngStyle]="{
                background: getBackground(),
                width: getPercentage() === 100 || getPercentage() >= 100 ? 100 + '%' : getPercentage() + '%'
              }"
            ></span>
          </div>
        </div>
        <div class="cursor" *ngIf="zone.max_capacity">
          <div [ngStyle]="{ 'margin-left': getPercentage() === 100 || getPercentage() >= 100 ? 'calc(' + 100 + '% - 27px)' : 'calc(' + getPercentage() + '% - 27px)' }">
            <span class="top-icon">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="11.5"
                  y="0.893555"
                  width="15"
                  height="15"
                  transform="rotate(45 11.5 0.893555)"
                  [ngStyle]="{ fill: getPercentage() >= 100 ? '#CE1126' : getPercentage() < 100 && getPercentage() >= 75 ? '#F97017' : '#2CCD59' }"
                />
              </svg>
            </span>
            <span class="percent-num" [ngStyle]="{ background: getPercentage() >= 100 ? '#CE1126' : getPercentage() < 100 && getPercentage() >= 75 ? '#F97017' : '#2CCD59' }">
              {{ getPercentage() }}%
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container container-all py-4" *ngIf="zone === '#all$'">
  <div class="d-flex justify-content-center row-cols-1 row-cols-md-2 row-cols-xl-3 flex-wrap">
    <div *ngFor="let eachzone of zones" class="px-4">
      <div class="capacity-details">
        <div class="show-capacity-card-ALL" *ngIf="show">
          <div class="card-content">
            <div class="title" (click)="viewCardDetails()">
              {{ eachzone.name }}
            </div>
            <div class="capacity-numbers" (click)="viewCardDetails()">
              <span class="current-num" [ngStyle]="{ color: getBackground(eachzone) }">{{ eachzone.checkinCount }}</span>
              <span *ngIf="eachzone.max_capacity" class="total">{{ '/' + eachzone?.max_capacity }}</span>
            </div>
            <div (click)="viewCardDetails()" class="notice" *ngIf="eachzone.max_capacity && !showSettings" [ngStyle]="{ display: getPercentage() < 75 ? 'none' : 'block' }">
              <span *ngIf="getPercentage(eachzone) >= 75 && getPercentage(eachzone) < 100" [ngStyle]="{ color: getPercentage(eachzone) >= 100 ? '#CE1126' : '#F97017' }"
                >Almost full</span
              >
              <span *ngIf="getPercentage(eachzone) >= 100" [ngStyle]="{ color: getPercentage(eachzone) >= 100 ? '#CE1126' : '#F97017' }">Over limit</span>
            </div>
            <div class="settings-placeholder" style="height: 45px" *ngIf="!showSettings" (click)="viewCardDetails()"></div>
            <div class="progress-bar" *ngIf="eachzone.max_capacity" (click)="viewCardDetails()">
              <div class="bar">
                <span
                  class="bar-bg"
                  [ngStyle]="{
                    background: getBackground(eachzone),
                    width: getPercentage(eachzone) === 100 || getPercentage(eachzone) >= 100 ? 100 + '%' : getPercentage(eachzone) + '%'
                  }"
                ></span>
              </div>
            </div>
            <div class="cursor" *ngIf="eachzone.max_capacity">
              <div
                [ngStyle]="{
                  'margin-left': getPercentage(eachzone) === 100 || getPercentage(eachzone) >= 100 ? 'calc(' + 100 + '% - 27px)' : 'calc(' + getPercentage(eachzone) + '% - 27px)'
                }"
              >
                <span class="top-icon">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect
                      x="11.5"
                      y="0.893555"
                      width="15"
                      height="15"
                      transform="rotate(45 11.5 0.893555)"
                      [ngStyle]="{ fill: getPercentage(eachzone) >= 100 ? '#CE1126' : getPercentage(eachzone) < 100 && getPercentage(eachzone) >= 75 ? '#F97017' : '#2CCD59' }"
                    />
                  </svg>
                </span>
                <span
                  class="percent-num"
                  [ngStyle]="{ background: getPercentage(eachzone) >= 100 ? '#CE1126' : getPercentage(eachzone) < 100 && getPercentage(eachzone) >= 75 ? '#F97017' : '#2CCD59' }"
                >
                  {{ getPercentage(eachzone) }}%
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="capacity-card-ALL" *ngIf="!show" [ngStyle]="{ background: getBackground(eachzone) }">
          <div class="card-content" (click)="viewCardDetails(i)">
            <div class="title">
              {{ eachzone.name }}
            </div>
            <div class="capacity-numbers" *ngIf="eachzone?.max_capacity">
              {{ eachzone?.max_capacity - (Object.prototype.hasOwnProperty.call(eachzone, 'checkinCount') ? eachzone.checkinCount : checkinCount) }}
            </div>
            <div class="capacity-numbers" *ngIf="!eachzone?.max_capacity">
              <mat-icon class="infinit-number">all_inclusive</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
